import Header from './Header';
import messages from './i18n/index';

export { messages };

export default Header;
